import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { FinanceService } from '../services/finance.service';

@Component({
  selector: '',
  template: '',
})
export class TeamBalanceDetailsSearchHandler extends BaseSearchComponent<FinanceService> implements OnInit {
  public searchName: string;
  isAdvanceSearchDisplayed: boolean;
  searchCriteriaData: any;

  constructor(
    public service: FinanceService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.searchName = 'SearchLeaderBalanceDetails';
    this.isAdvanceSearchDisplayed = true;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'TeamBalanceDetails',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('TeamBalanceDetails');
    return header;
  }
}
